<template>

    <div class="login-form">
        <form @submit.prevent="loginSubmit">
        <img class="logo" src="@/assets/HeaderLogo.svg"/>
        <div style="height: 30px;margin-top: 8px; font-size: 12px; color: red">
            {{errors}}
        </div>
        <div>
            <BaseInput v-model="userName" :label="$t('login.userName')" :placeholder="$t('login.userNamePlaceholder')" autocomplete="username"/>
        </div>
        <div  style="margin-top: 20px">
            <BaseInput v-model="passWord" type="password" :label="$t('login.passWord')" :placeholder="$t('login.passWordPlaceholder')" autocomplete="current-password"/>
        </div>
        <div style="margin-top: 40px;display: flex;justify-content: space-between">
            <button class="button-primary button-primary__inverse" type="submit" >{{$t('login.loginButton')}}</button>
            <button class="button-primary" type="button" @click="forgotPass">{{$t('login.forgotPassword')}}</button>
        </div>
        </form>
    </div>
</template>

<script>
    import BaseInput from "./inputs/BaseInput";
    import {ref} from 'vue'
    import { useStore } from 'vuex'
    import { useRouter } from 'vue-router'

    export default {
        name: "LoginForm",
        components: {BaseInput},
        data(){
            return{

            }
        },
        setup(){
            const userName = ref('');
            const passWord = ref('');
            const store = useStore();
            const errors = ref('');
            const router  = useRouter();
             function loginSubmit() {
                errors.value = ''
                store.dispatch('tokenLogin',{username:userName.value,password:passWord.value}).then((res)=>{
                    console.log(res)
                    router.push({
                        name:'FrontPage'
                    })
                }).catch((msg) => {
                    console.log("not")
                    errors.value = msg
                });
            }
            function forgotPass () {
                console.log("do something here")
            }

            return {
                userName,
                passWord,
                errors,
                loginSubmit,
                forgotPass
            }
        },
        methods: {

        }
    }
</script>

<style scoped>

</style>
